import { HighlightedText } from '@/app/components/HighlightedText';
import { getPath } from '@/consts/paths';
import type { GlobalSearchFaqItem } from '@/types/globalSearchApiTypes';
import { SearchItemTitle } from '../SearchItemTitle';
import { SearchItemWrapper } from '../SearchItemWrapper';
import QuestionCircleIcon from '/public/icons/question-circle.svg';

interface FaqItemProps {
  item: GlobalSearchFaqItem;
}

export const FaqItem = ({ item }: FaqItemProps) => {
  return (
    <SearchItemWrapper href={getPath(item.redirect_url)}>
      <div className="flex items-center gap-2">
        <QuestionCircleIcon className="w-5 h-5 text-black flex-shrink-0 self-start mt-1 max-md:mt-1.5 max-md:mx-1.5" />
        <div className="flex flex-col gap-1 min-w-0">
          <SearchItemTitle truncate>{item.question}</SearchItemTitle>
          <p className="text-body-small text-grey-700 !leading-[140%] truncate">
            <HighlightedText>{item.answer}</HighlightedText>
          </p>
        </div>
      </div>
    </SearchItemWrapper>
  );
};
